import useGetFeatures from './useGetFeatures';

export { useGetFeatures };
